module.exports = __webpack_public_path__ + "img/cooperation5.129b3445.png";